import React from 'react';
import Translate, {t} from "../../../components/Translate";

const FileForm = ({
                      isFormVisible,
                      toggleFormVisibility,
                      editingFileKeyName,
                      newFile,
                      handleInputChange,
                      inputError,
                      locales,
                      fileInputRefs,
                      handleFileChange,
                      currentUser,
                      handleSaveEdit,
                      handleAddFile,
                      handleDescriptionChange,
                      description
                  }) => {

    if (!isFormVisible) return null;

    return (
        <div className="modal-overlay" onClick={toggleFormVisibility}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3>{editingFileKeyName ? t(currentUser.language, "editFile") : t(currentUser.language, "addNewFile")}</h3>
                <div className={`add-file-form ${isFormVisible ? 'visible' : 'hidden'}`}>
                    <input
                        type="text"
                        className="add-input"
                        name="keyName"
                        placeholder={t(currentUser.language, "fileKey")}
                        value={editingFileKeyName ? editingFileKeyName : newFile.keyName}
                        onChange={handleInputChange}
                        disabled={!!editingFileKeyName}
                    />
                    {inputError && <div className="new-key-error-message">{inputError}</div>}
                    <input
                        type="text"
                        className="add-input"
                        name="description"
                        placeholder={t(currentUser.language, "description")}
                        value={description}
                        onChange={handleDescriptionChange}
                    />

                    {locales.map((locale) => (
                        <div className="file-locale-div" key={locale.locale}>
                            <div className="file-locale-item">{locale.locale}</div>
                            :
                            <input
                                name={locale.locale}
                                ref={el => fileInputRefs.current[locale.locale] = el}
                                type="file"
                                className="add-input file-add-input"
                                onChange={(e) => handleFileChange(e, locale.locale)}
                            />
                        </div>
                    ))}

                    <div>
                        <button className={'modal-button cancel'} onClick={toggleFormVisibility}>
                            <Translate language={currentUser.language} text="closeForm"/>
                        </button>
                        {editingFileKeyName ? (
                            <button className={'modal-button confirm'}
                                    onClick={handleSaveEdit}>
                                <Translate language={currentUser.language} text="save"/>
                            </button>
                        ) : (
                            <button
                                disabled={inputError === t(currentUser.language, "newKeyErrorMessage")}
                                className={'modal-button confirm'}
                                onClick={handleAddFile}
                            >
                                <Translate language={currentUser.language} text="add"/>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FileForm;
